import PatreonButton from './PatreonButton'

PatreonButton.install = function install (Vue) {
  Vue.component(PatreonButton.name, PatreonButton)
}

export default PatreonButton



// WEBPACK FOOTER //
// ./src/components/patreon-button/index.js